export default {
  SET_PROJECT_DETAILS: 'SET_PROJECT_DETAILS',
  SELECT_REQUEST_DETAILS: 'SELECT_REQUEST_DETAILS',
};
